
import { defineComponent } from "vue";
import {
  dismissUnansweredQuestion,
  listUnansweredQuestions
} from "@/api/unansweredQuestions.api";

export default defineComponent({
  name: "unanswered-questions",
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  emits: ["navigate"],
  data() {
    return {
      loading: true,
      loadError: "",
      questions: [] as any[],
      dismissingId: 0
    };
  },
  mounted() {
    this.loadQuestions();
  },
  methods: {
    async loadQuestions() {
      this.loading = true;
      this.loadError = "";
      try {
        const response = await listUnansweredQuestions({ status: "open" });
        this.questions = response.data?.questions || [];
      } catch (err) {
        this.loadError = err?.message || "Failed to load unanswered questions.";
      } finally {
        this.loading = false;
      }
    },
    async dismiss(item: any) {
      this.dismissingId = item.id;
      try {
        await dismissUnansweredQuestion(item.id);
        this.questions = this.questions.filter((row) => row.id !== item.id);
      } catch (err) {
        this.loadError = err?.message || "Failed to dismiss question.";
      } finally {
        this.dismissingId = 0;
      }
    },
    formatDate(value: string) {
      if (!value) return "—";
      return new Date(value).toLocaleString();
    },
    truncateReply(value: string) {
      const text = String(value || "").trim();
      if (text.length <= 120) return text;
      return `${text.slice(0, 117)}...`;
    }
  }
});
